import { ReactComponent as ArrowBackFootedIcon } from './arrow_back_footed.svg';

export default ArrowBackFootedIcon;
